import "./Mascot.css";
import mascot from "../images/ZETY.png";

export default function Mascot({
  message,
  onToggleChat,
}) {
  const handleClick = () => {
    onToggleChat?.();
  };

  const spokenMessage = (message || "").replace(/\n/g, " ");

  return (
    <div
      className="mascot-container"
      onClick={handleClick}
      role="button"
      tabIndex={0}
      aria-haspopup="dialog"
      aria-controls="techizen-chat-panel"
      aria-label={`Open the Techizen AI assistant chat. ${spokenMessage}`}
      onKeyDown={(e) => {
        if (e.key === "Enter" || e.key === " " || e.key === "Spacebar") {
          e.preventDefault();
          handleClick();
        }
      }}
    >
      <div className="mascot-shadow" aria-hidden="true"></div>

      <img loading="eager" decoding="async"
        src={mascot}
        alt=""
        aria-hidden="true"
        className="mascot"
      />

      <div className="speech-bubble" aria-hidden="true">
        {message.split("\n").map((line, index) => (
          <div key={index}>{line}</div>
        ))}
      </div>

      <div className="floating-ring ring1" aria-hidden="true"></div>
      <div className="floating-ring ring2" aria-hidden="true"></div>
      <div className="floating-ring ring3" aria-hidden="true"></div>

      <div className="floating-dot dot1" aria-hidden="true"></div>
      <div className="floating-dot dot2" aria-hidden="true"></div>
      <div className="floating-dot dot3" aria-hidden="true"></div>
    </div>
  );
}
